import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

const Notifications = ({ open, onCancel, data: notifications }) => {
	// console.log(notifications)
	return (
		<Dialog onClose={onCancel} open={open} fullWidth>
			<DialogTitle id="simple-dialog-title">Notifications</DialogTitle>
			<DialogContent dividers>
				<List>
					<For each="notification" index="index" of={notifications}>
                        <ListItem disableGutters key={index}>
                            <ListItemText primary={notification.text} secondary={notification.timeStamp} />
                        </ListItem>
                    </For>
				</List>
			</DialogContent>
		</Dialog>
	);
};

export default Notifications;